import { TFunction } from './use-translation'

export const SUPPORTED_LANGUAGES = ['en', 'ja', 'ko'] as const

export type LanguageMapKeys = (typeof SUPPORTED_LANGUAGES)[number] | ''

export const getLanguageOptions = (t: TFunction) => {
  return [
    {
      value: '',
      label: t('common:noLanguageSelected', 'No language selected'),
    },
    { value: 'en', label: t('common:english', 'English') },
    { value: 'ja', label: t('common:japanese', 'Japanese') },
    { value: 'ko', label: t('common:korean', 'Korean') },
  ]
}
